import ReceiveList from './ReceiveList';
export default ReceiveList;
